module.exports = __webpack_public_path__ + "app/assets/images/man18-d06e3bd00a4694430ed360a1f4d2aeb2.jpg";